<template>
  <div class="ts-justify-start">
    <!-- File Image -->
    <img
      v-if="isImage && !isIcon"
      class="h-full w-full rounded-lg object-cover shadow-lg"
      :src="entry.data.attributes.file_url"
      alt=""
      loading="lazy"
      style="max-height: 106px;"
    />
    <i
      v-if="isImage && isIcon"
      :class="iconSize"
      class="fas fa-file-image text-primary"
    ></i>

    <!-- File PDF -->
    <i v-if="isPdf" :class="iconSize" class="fas fa-file-pdf text-danger"></i>

    <!-- File Word -->
    <i
      v-if="isWord"
      :class="iconSize"
      class="fas fa-file-word ts-text-blue-700"
    ></i>

    <!-- File Excel -->

    <i
      v-if="isExcel"
      :class="iconSize"
      class="fas fa-file-excel ts-text-green-500"
    ></i>

    <!-- File Text -->
    <i v-if="isText" :class="iconSize" class="fas fa-file-alt"></i>

    <!-- File audio -->

    <i
      v-if="isAudio"
      :class="iconSize"
      class="fas fa-volume-up ts-text-pink-500"
    ></i>
    <!-- File video -->

    <i
      v-if="isVideo"
      :class="iconSize"
      class="fas fa-play-circle ts-text-red-600"
    ></i>
    <!-- File Archive -->

    <i
      v-if="isArchive"
      :class="iconSize"
      class="fas fa-file-archive ts-text-purple-600"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'FileIconThumbnail',
  props: ['entry', 'iconSize', 'isIcon'],
  computed: {
    isImage () {
      return this.entry.data.type === 'image'
    },
    isPdf () {
      return this.entry.data.attributes.mimetype === 'pdf'
    },
    isWord () {
      return (
        this.entry.data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
    },
    isExcel () {
      return (
        this.entry.data.attributes.mimetype ===
        'vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    },
    isText () {
      return this.entry.data.attributes.mimetype === 'plain'
    },
    isArchive () {
      return this.entry.data.attributes.mimetype === 'zip'
    },
    isVideo () {
      return this.entry.data.type === 'video'
    },
    isAudio () {
      let mimetypes = ['mpeg', 'mp3', 'mp4', 'wan', 'flac', 'ogg']
      return (
        mimetypes.includes(this.entry.data.attributes.mimetype) &&
        this.entry.data.type === 'audio'
      )
    },
    timeStamp () {
      return this.entry.data.attributes.deleted_at
        ? this.$t('entry_thumbnail.deleted_at', {
            time: this.entry.data.attributes.deleted_at
          })
        : this.entry.data.attributes.created_at
    }
  }
}
</script>
